module.exports = __webpack_public_path__ + "media/newstyle/images/icon-arrow-down-grey-83e2e29669c7e773b7ac829126a2799c.svg";